import Sortable from 'sortablejs';

document.addEventListener('DOMContentLoaded', function() {
  let MANAGE_PRESET_FILE_LIMITS = $('#manager_preset_file_limits').val() && JSON.parse($('#manager_preset_file_limits').val());
  let fileObject = {};
  let croppie_manager_preset = '';
  const languageSelector = document.getElementById("language-selector");
  if(languageSelector){
    languageSelector.onchange = function (event) {
      const form = event.target.closest("form");
      if (form && form.classList.contains("language-selector-form")) {
        if(formChanged){
          const confirmation = confirm('You have unsaved changes. Are you sure you want to leave? All unsaved data will be lost if you click \'OK\'');
          if (!confirmation) {
            event.preventDefault();
          }
          else{
            formChanged = false;
            form.submit();
          }
        }
        else{
          form.submit();
        }
      }
    }
  }
  const dashboardMessageType = document.getElementById('dashboard-message-selector');
  if (dashboardMessageType) {
    dashboardMessageType.onchange = function (event) {
      const selectedValue = event.target.value;
      const mainContent = document.getElementById('main-preset-dashboard-content');
      const dashboardImage = document.getElementById('dashboard-content-image-section');
      const dashboardVideo = document.getElementById('dashboard-content-video-section');
      formChanged = true;
      alert("This change will be applied for all dashboard languages within this preset.");

      mainContent.classList.toggle("display-none", selectedValue === "none");

      if (selectedValue !== "none") {
        dashboardImage.classList.toggle("display-none", selectedValue !== "image");
        dashboardVideo.classList.toggle("display-none", selectedValue !== "video");
      }
    };
  }
  let formChanged = false;
  // handled crop and deletion of image
  let dashboardForm = document.getElementById("manager_preset_edit_form");
  if (dashboardForm){
    setupUnsavedChangesAlert(dashboardForm);
    dashboardForm.addEventListener('submit', function(e) {
      e.preventDefault();
      formChanged = false;
      dashboardForm.querySelectorAll('.content-image-container').forEach(function(imageUploaded) {
        let imgSrc = imageUploaded.querySelector('img').getAttribute('src');
        if (imgSrc !== undefined && imgSrc !== null && imgSrc.indexOf("base64") !== -1) {
          imageUploaded.querySelector('.content-for-image').value = (imgSrc.replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, ""))
        } else if (imgSrc === undefined || imgSrc === null) {
          imageUploaded.querySelector('.content-for-image').value = 'null';
        }
      });
      
      dashboardForm.querySelectorAll('.manager-preset-video-container').forEach(function(videoUploaded) {
        let videoSrc = videoUploaded.querySelector("video").getAttribute('src');
        if (videoSrc && videoSrc.indexOf("base64") !== -1) {
          videoUploaded.querySelector('.content-for-video').value = (videoSrc.replace(/^data:video\/(mp4|mov);base64,/, ""));
        } 
        else {
          let srcElement = videoUploaded.querySelector("video source");
          if(srcElement){
            let sourceSrc = srcElement.getAttribute('src');
            if(sourceSrc === null || sourceSrc === ''){
              videoUploaded.querySelector('.content-for-video').value = null;
            }
          }
          else 
          {
            videoUploaded.querySelector('.content-for-video').value = null;
          }
        }
      });
      
      dashboardForm.querySelectorAll('.video-subtitle-container').forEach(function(contentUploaded) {
        let contentSrc = contentUploaded.querySelector("#welcome_video_subtitles").value
        if (contentSrc !== undefined && contentSrc !== null && contentSrc.indexOf("base64") !== -1) {
          contentUploaded.querySelector('.content-for-subtitle').value = (contentSrc.replace(/^data:text\/(vtt);base64,/, "").replace(/^data:application\/(octet-stream);base64,/, ""))
        } else if (contentSrc === undefined || contentSrc === null || contentSrc === '' ) {
          contentUploaded.querySelector('.content-for-subtitle').value = 'null';
        }
      });
      
      dashboardForm.querySelectorAll('.video-thumbnail-container').forEach(function(thumbnailUploaded) {
        let image = thumbnailUploaded.querySelector('img');
        if (image){
          let imgSrc = image.getAttribute('src');
          if (imgSrc && imgSrc !== undefined && imgSrc !== null && imgSrc.indexOf("base64") !== -1) {
            thumbnailUploaded.querySelector('.content-for-video-thumbnail').value = (imgSrc.replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, ""))
          }
        }
      });
      dashboardForm.submit();
    });
  }
  const manager_introduction_ckb = document.getElementById('checkbox_manager_introduction');
  if (manager_introduction_ckb){
    let hiddenField = document.getElementById('hidden_manager_introduction');
    manager_introduction_ckb.addEventListener('change', function() {
      if (manager_introduction_ckb.checked) {
        hiddenField.value = 'true';
      } else {
        hiddenField.value = 'false';
      }
    });
  }
  let managerPresetStyleSheetForm = document.getElementById('manager-preset-style-sheet-form');
  if (managerPresetStyleSheetForm){
    let styleSections     = managerPresetStyleSheetForm.querySelectorAll(".style-attributes-section");
    const onlyGoogleFonts = $('#only_google_fonts').val() && JSON.parse($('#only_google_fonts').val());
    styleSections.forEach(function(section){
      let font    = section.querySelector('.font-selector');
      let weight  = section.querySelector('.font-weight-selector');
      let color   = section.querySelector('.color-selector');
      let preview = section.querySelector('.preview-text-area');
      if(font){
        getGoogleFonts(font.value);
        font.onchange = function(){
          getGoogleFonts(font.value);
          formChanged              = true
          preview.style.fontFamily = font.value
        }
      }
      if(weight){
        weight.onchange = function(){
          formChanged              = true
          preview.style.fontWeight = weight.value
        }
      }
      if(color){
        color.onchange = function(){
          formChanged              = true
          preview.style.color      = color.value
        }   
      }
    });
    function getGoogleFonts(font) {
      let fonts = [];
      if ( onlyGoogleFonts.includes(font) ) {
        fonts.push(font);
      }
      if (fonts.length > 0) {
        try {
          WebFont.load({
            google: {
              families: fonts
            }
          });
        } catch (e) {
          console.error(e)
        }
      }
    }
  }
  let managerPresetSelector = document.getElementById("manager-preset-selector");
  if (managerPresetSelector){
    managerPresetSelector.onchange = function (event) {
      const form = event.target.closest("form");
      if (form && form.classList.contains("manager-preset-selector-form")) {
        if(formChanged){
          const confirmation = confirm('You have unsaved changes. Are you sure you want to leave? All unsaved data will be lost if you click \'OK\'');
          if (!confirmation) {
            event.preventDefault();
          }
          else{
            formChanged = false;
            form.submit();
          }
        }
        else{
          form.submit();
        }
      }
    }
  }
  let alertEnabledForms = document.querySelectorAll(".alert-enabled-before-leave");
  if (alertEnabledForms){
    alertEnabledForms.forEach(function(form){
      setupUnsavedChangesAlert(form);
      form.addEventListener('submit', function(e) {
        formChanged = false;
      });
    });
  }
  document.querySelectorAll('.manager-toolkit-checkbox-warning').forEach(function(checkbox) {
    const originalState = checkbox.checked;
    checkbox.addEventListener('change', function() {
      const dataExist = checkbox.dataset.dataExists;
      const form      = checkbox.closest('form');
  
      if (!this.checked && dataExist && originalState) {
        const confirmation = confirm('Are you sure you would like to disable this functionality? We will hide it from the player side, however your data will not be deleted');
        if (!confirmation) {
          this.checked = originalState;
          return;
        }
      }
      formChanged = false;
      form.submit();
    });
  });
  
  function handleFileChange(event, fileType) {
    const container      = $(this).parents('.content-image-container');
    const filePreview    = container.find(".upload-preview-manager-preset-image img");
    const altTextModal   = container.find(".edit-alt-text-image-modal");
    const fileTypeInput  = container.find(".type-for-image");
    const fileNameInput  = container.find(".name-for-image");
    const removeImageBtn = container.find('.remove-manager-preset-image');
    const cropBtn        = container.find(".edit-manager-preset-image-modal");

    let input = $(event.currentTarget);
    let file = input[0].files[0];

    if (!file) return;

    if (fileSizeNotInLimit(file, event, fileType, MANAGE_PRESET_FILE_LIMITS[fileType])) return;

    fileTypeInput.val(file.type);
    fileNameInput.val(file.name);
    altTextModal.removeClass("display-none");
    cropBtn.removeClass("display-none");

    removeImageBtn.css({
        "opacity": 1,
        "pointer-events": "all"
    });

    const reader = new FileReader();
    reader.onload = function (e) {
        filePreview.attr("src", e.target.result);
    };

    reader.readAsDataURL(file);
    this.value = "";
  }

  $(".upload-manager-preset-image-file").change(function (event) {
      handleFileChange.call(this, event, "image");
  });

  $(".upload-manager-preset-logo-file").change(function (event) {
      handleFileChange.call(this, event, "logo");
  });

  $(".upload-manager-preset-manager-image-file").change(function (event) {
    handleFileChange.call(this, event, "manager_image");
  });

  $('.remove-manager-preset-image').click(function (event) {
    $($(event.target)[0]).parents('.content-image-container').find('.upload-preview-manager-preset-image').find("img").attr("src", null);
    $($(event.target)[0]).parents('.content-image-container').find('.edit-alt-text-image-modal').addClass("display-none");
    $($(event.target)[0]).parents('.content-image-container').find('.edit-manager-preset-image-modal').addClass("display-none");
    $(this).css("opacity", 0.5);
    $(this).css("pointer-events", "none");
  });

  $(".edit-manager-preset-image-modal").click(function (event) {
    $("#image_modal").openModal();
    $("#image_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');
    let cropbox = '#manager_preset_edit_image_cropbox';
    $(cropbox).attr("src", $("#uploaded-image")[0].src);
    let details = $(this).data('file-details').split(',');
    if (!fileObject.filetype_image && details.length > 1) {
      $(this).parents('.content-image-container').find('.name-for-image').val(details[0]);
      $(this).parents('.content-image-container').find('.type-for-image').val(details[1].slice(1));
    }

    $(".upload-preview").removeClass("upload-preview");
    $($(event.target)[0]).parent().addClass("upload-preview");
    $('#editCropManagerPresetImageModal').find(".upload-preview-manager-preset-image-sec").addClass("upload-preview");

    let element = $(cropbox);
    let modal = '#editCropManagerPresetImageModal';
    let croppie = '.croppie-image';

    croppie_manager_preset = $(croppie).croppie({
      viewport: {
        width: parseInt(element.attr('data-width')),
        height: parseInt(element.attr('data-height'))
      }
    });

    if ($(modal).find('.croppie-container').length > 1) {
      $(modal).find('.croppie-container:last').appendTo(`${modal} .main-image-container`);
      $(modal).find('.croppie-container:first').remove();
    }
  });

  $('.save-cropped-image-btn').click(function () {
    if (croppie_manager_preset) {
      let src = croppie_manager_preset.get(0).src;
      let format = croppie_manager_preset.get(0).src.split(';')[0].split('/')[1];
      if (!format) {
        format = 'jpeg';
      }

      croppie_manager_preset.croppie('result', {
        type: 'canvas',
        size: 'original',
        format: format,
        quality: '0.99'
      }).then(function (response) {
        $('.upload-preview img').attr('src', response);
      });
    }
  });
  
  $(".edit-manager-preset-video").change(function (event) {
    if ($(this)[0].files[0] && ($(this)[0].files[0].size / 1024 / 1024) > 90) {
      $(this).val('');
      alert("Uploaded video exceeds maximum file size of 90MB");
    } else if ($(this)[0].files[0]) {
      let file_preview = $(event.target).parents('.manager-preset-video-container').find(".upload-preview-manager-preset-video").find("video");

      let input = $(event.currentTarget);
      let file = input[0].files[0];

      $(this).parents('.manager-preset-video-container').find(".type-for-video").val(file.type);
      $(this).parents('.manager-preset-video-container').find(".name-for-video").val(file.name);

      $(this).parents('.manager-preset-video-container').find('.remove-manager-preset-video').css("opacity", 1);
      $(this).parents('.manager-preset-video-container').find('.remove-manager-preset-video').css("pointer-events", "all");
      $(this).parents('.manager-preset-video-container').find('.video-thumbnail-container').removeClass("display-none");
      let reader = new FileReader();
      reader.onload = function (e) {
        let image_base64 = e.target.result;
        image_base64 = image_base64.replace("quicktime", "mp4");
        file_preview.get(0).removeAttribute("crossorigin");
        file_preview.attr("src", image_base64);
        file_preview.attr("poster", '');
        return;
      };
      reader.readAsDataURL(file);
    }
  });

  $('.remove-manager-preset-video').click(function (event) {
    let main_vid             = $($(event.target)[0]).parents('.manager-preset-video-container').find('.upload-preview-manager-preset-video').find("video");
    let thumb_nail_container = $($(event.target)[0]).parents('.manager-preset-video-container').find('.video-thumbnail-container');
    thumb_nail               = thumb_nail_container.find("img");
    main_vid.attr("src", '');
    main_vid.attr("src", null);
    main_vid.attr("poster", '');
    main_vid.find('source').attr("src", null);
    thumb_nail.attr('src', null);
    thumb_nail_container.addClass("display-none");
    $(this).parents('.cs-trash').css("opacity", 0.5);
    $(this).parents('.cs-trash').css("pointer-events", "none");
  });

  $(".capture-manager-video-thumbnail").click(function (event) {
    let video = $(this).parents('.manager-preset-video-container').find('.upload-preview-manager-preset-video').find("video").get(0);
    if (video != undefined) {
      $(this).parents('.video-thumbnail-container').find('.display-thumbnail').html('');
      let canvas = document.createElement('canvas');
      let context = canvas.getContext('2d');
      context.canvas.width = video.videoWidth;
      context.canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      try {
        let dataURL = canvas.toDataURL();
        let img = document.createElement('img');
        img.setAttribute('src', dataURL);
        $(this).parents('.video-thumbnail-container').find('.display-thumbnail').html(img);
        $(this).parents('.video-thumbnail-container').find('.display-thumbnail').find('img').css("max-width", "100%");
        $(this).parents('.video-thumbnail-container').find('.preview-text').removeClass("display-none");
      } catch (err) {
        console.log(err.message);
      }
    }
  });

  $(".edit-manager-preset-video-subtitles").change(function (event) {
    if ($(this)[0].files[0]) {
      let file_preview = $(this).siblings('#welcome_video_subtitles');
      let input = $(event.currentTarget);
      let file = input[0].files[0];

      $(this).parents('.video-subtitle-container').find(".type-for-subtitle").val(file.type);
      $(this).parents('.video-subtitle-container').find(".name-for-subtitle").val(file.name);

      $(this).parents('.video-subtitle-container').find('.video-subtitles-file').show();
      $(this).parents('.video-subtitle-container').find('.manager_video_subtitle_file_remove_btn').show();
      $(this).parents('.video-subtitle-container').find('.video-subtitles-file').find('h6').text(file.name);

      let reader = new FileReader();
      reader.onload = function (e) {
        let image_base64 = e.target.result;
        file_preview.val(image_base64);
        return;
      };
      reader.readAsDataURL(file);
    }
  });

  $('.alt-cancel-button-manager-toolkit').on('click', function (e) {
    const defaultAltText = $(this).parents('.modal-content').find('.alt-text-default-value').val();
    const characterCounter = $(this).parents('.modal-content').find('.char_counter');
    $(this).parents('.modal-content').find('.alt-modal-text-area').val(defaultAltText);
    characterCounter.text(defaultAltText.length + '/' + "140" + ' Characters');
  });

  $('.manager_video_subtitle_file_remove_btn').click(function (event) {
    $($(event.target)[0]).parents('.video-subtitle-container').find('.edit-manager-preset-video-subtitles').val(null);
    $($(event.target)[0]).parents('.video-subtitle-container').find('.video-subtitles-file').find('h6').text('');
    $(this).css("display", 'none');
  });
  
  const managerToolkitModals = document.querySelectorAll(".manager-toolkit-modal");
  if (managerToolkitModals) {
    managerToolkitModals.forEach((modal) => {
      resetTextArea(modal); 
    });
  }

  function resetTextArea(modal) {
    $(document).on('click', function (e) {
      const isModalOpen = $(modal).css("display") == "block";
  
      if (isModalOpen) {
        const modalContent = $(modal).find('.modal-content');
        const isInsideModal = modalContent.has(e.target).length > 0 || modalContent.is(e.target);
  
        if (!isInsideModal) {
          const defaultAltText = modalContent.find('.alt-text-default-value').val();
          const characterCounter = modalContent.find('.char_counter');
          const altTextArea = modalContent.find('.alt-modal-text-area');
          
          altTextArea.val(defaultAltText);
          characterCounter.text(defaultAltText.length + '/' + '140' + ' Characters');
        }
      }
    });
  }

  function setupUnsavedChangesAlert(form) {
    form.addEventListener('change', function () {
      formChanged = true;
    });
    
    let buttons = document.querySelectorAll(".check-for-from-changes");
    if (buttons){
      buttons.forEach((button) => {
        button.addEventListener("click", function(e){
          if (formChanged){
            const confirmation = confirm('You have unsaved changes. Are you sure you want to leave? All unsaved data will be lost if you click \'OK\'');
            if (!confirmation) {
              e.preventDefault();
            }
            else{
              formChanged = false;
            }
          }
        });
      });
    }
    
    let dropDowns = form.querySelectorAll(".trigger-form-changed");
    if(dropDowns){
      dropDowns.forEach((dropDown) => {
        dropDown.onchange = function () {
          formChanged = true;
        }
      });
    }
    
    form.addEventListener('input', function () {
      formChanged = true;
    });
    
    for (const instanceName in CKEDITOR.instances) {
      if (CKEDITOR.instances.hasOwnProperty(instanceName)) {
        let ckEditorInstance = CKEDITOR.instances[instanceName];
        if (ckEditorInstance) {
          ckEditorInstance.on('change', function () {
            formChanged = true;
          });
        }
      }
    }

    const backButton = document.getElementById('manager-toolkit-back-button');
    if (backButton){
      backButton.addEventListener("click", function(e){
        if (formChanged){
          const confirmation = confirm('You have unsaved changes. Are you sure you want to leave? All unsaved data will be lost if you click \'OK\'');
          if (!confirmation) {
            e.preventDefault();
          }
          else{
            formChanged = false;
          }
        }
      });
    }
    
    const sideMenuButtons = document.querySelectorAll('.side-menu-items-editor');
    if(sideMenuButtons){
      sideMenuButtons.forEach(button => {
        button.addEventListener('click', function(event){
          if(formChanged){
            const confirmation = confirm('You have unsaved changes. Are you sure you want to leave? All unsaved data will be lost if you click \'OK\'');
            if (!confirmation) {
              event.preventDefault();
            }
            else{
              formChanged = false;
            }
          }
        });
      });
    }
    const images = form.querySelectorAll(".check-image-changes");
    if (images.length > 0) {
      images.forEach(function(image) {
        const observer = new MutationObserver(function(mutationsList, observer) {
          for(const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
              formChanged = true;
              break;
            }
          }
        });
        const observerConfig = { attributes: true, attributeFilter: ['src'] };
        observer.observe(image, observerConfig);
      });
    }

    window.addEventListener('beforeunload', function (e) {
      if (formChanged) {
        let confirmationMessage = 'You have unsaved changes. Are you sure you want to leave?';
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
      }
    });
  }

  $('#add_manager_preset_languages').change(function (event) {
    let val = $(event.target).val();
    if (val !== "0") {
      formChanged = true;
      let selected = $(event.target).find('option:selected');
      let language_id = selected.attr("data-language-id");
      let dup = $('#add-new-language-row').clone();
      $(dup).attr("id", "");
      $(dup).find('.language-name .name-of-language').text(val);
      $($(dup).find('.language-name .flag-icon')[0]).addClass(selected.attr("data-flag-class"));
      $(dup).find('#manager_preset_language_default_0').val(language_id);
      $(dup).find('#manager_preset_language_default_0').attr("id", "manager_preset_language_default_" + language_id);
      $(dup).find("label[for='manager_preset_language_default_0']").text(language_id);
      $(dup).find("label[for='manager_preset_language_default_0']").attr("for", "manager_preset_language_default_" + language_id);
      let hiddenField = $('<input>').attr({
        type: 'hidden',
        id: 'manager_preset_manager_preset_language_ids_',
        name: 'manager_preset[manager_preset_language_ids][]',
        value: language_id
      });
      $(dup).append(hiddenField);
      $('#add-new-language-row').parent().append(dup);
      $(dup).css("display", "table-row");
      selected.css("display", "none");
      $(event.target).val("0");
      $(event.target).trigger("chosen:updated");

      $(dup).find('.remove-manager-preset-language').click(function () {
          remove_manager_preset_language_listener(this);
      });
      alert("Language added. Default content will be translated. Any custom content needs to be translated in order to display in the correct language for managers.");
    }
  });

  $('.remove-manager-preset-language').click(function () {
    remove_manager_preset_language_listener(this);
  });

  let remove_manager_preset_language_listener = function (object) {
    formChanged = true;
    let val = $(object).siblings('.language-name').html().trim();
    let checked = $(object).siblings().find('input[type="radio"]').is(":checked");
    if (checked === true) {
      alert("Default language cannot be deleted.");
    } else {
      const confirmation = confirm('Are you sure you would like to remove this language? All custom content added will be removed as well');
      if(confirmation){
        $(object).parent().remove();
        $('#add_manager_preset_languages').find('option[value="' + val + '"]').css("display", "block");
        $('#add_manager_preset_languages').trigger("chosen:updated");
      }
    }
  };

  const managerPresetsTips = document.querySelectorAll('.manager_toolkit-tips-index');
  if (managerPresetsTips.length > 0) {
    category_count = 0
    const tipLanguageElements = document.querySelectorAll('.tip-language');
    const tipCategoryLanguageElements = document.querySelectorAll('.tip-category-language');

    tipLanguageElements.forEach(function(element) {
      element.addEventListener('click', function(event) {
        const form = element.closest('form');
        form.querySelectorAll('.tip-language').forEach(function(langElement) {
          langElement.classList.remove('selected');
        });
        element.classList.add('selected');
        const l_id = element.getAttribute('data-language-id');
        const t_id = element.getAttribute('data-tip-id');

        form.querySelectorAll('.multi-lanuage-field').forEach(function(field) {
          field.style.display = 'none';
        });
        document.getElementById('tip-attachment-' + t_id + '-' + l_id).style.display = 'block';
        document.getElementById('tip-title-' + t_id + '-' + l_id).style.display = 'block';
        document.getElementById('tip-description-' + t_id + '-' + l_id).style.display = 'block';
      });
    });

    tipCategoryLanguageElements.forEach(function(element) {
      element.addEventListener('click', function(event) {
        const modal = element.closest('.modal');
        modal.querySelectorAll('.tip-category-language').forEach(function(langElement) {
          langElement.classList.remove('selected');
        });
        element.classList.add('selected');
        const l_id = element.getAttribute('data-language-id');
        const t_t_id = element.getAttribute('data-tip-type-id');

        modal.querySelectorAll('.multi-lanuage-field').forEach(function(field) {
          field.style.display = 'none';
        });
        modal.querySelectorAll('.add-category-container').forEach(function(container) {
          container.style.display = 'none';
        });
        modal.querySelectorAll('.tip-category-' + t_t_id + '-' + l_id).forEach(function(tipCategory) {
          tipCategory.style.display = 'block';
        });
      });
    });

    $('.add-tip-category-button').on('click', function (e) {
      e.preventDefault();
      window.allowAdd = false;
      let element = '';
      let l_ids = $(this).parents('form').find('#language_ids').val();
      l_ids = l_ids.split(',');
      let ln_id = $(this).data('language-id');
      let t_t_id = $(this).data('tip-type-id');
      let category_name = '';
      let category_container = '';
      
      if (t_t_id) {
        category_name = 'tip';
        category_container = t_t_id;
      }
    
      $(this).parents('.add-category-container').find('.add-category-input').hide();
      $(this).parents('.add-category-container').find('.add-tip-category-button').hide();
      $(this).parents('.add-category-container').find('.add-category-placeholder').show();
      
      let text = $(this).parents('.add-category-container').find('.add-category-input').val();
      
      if (text.length > 0) {
        $(this).parents('.add-category-container').find('.add-category-input').val('');
        let count = parseInt(($('.category-index-number').length / $(this).parents('form').find('#language_ids').val().split(',').length) + 1);
        
        for (let i = 0; i < l_ids.length; i++) {
          let l_id = l_ids[i];
          let display = '';
          let textt = '';
          let span_class = '';
          
          if (l_id == ln_id.toString()) {
            display = 'block';
            textt = text;
            span_class = '';
          } else {
            display = 'none';
            textt = '';
            span_class = 'grayed-out';
          }
          
          element += "<div class='edit-category-container multi-lanuage-field " + category_name + "-category-" + category_container + "-" + l_id + "' style='display: " + display + ";'>" +
                        "<span class='category-index-number'>" + count + "</span>" +
                        "<span data-name='" + textt + "' data-delete='false' class='order-item-name " + span_class + "'>" + text + "</span>" +
                        "<i class='category-order-icon fa fa-bars right active'></i>" +
                        "<input class='edit-category-input' id='category_" + category_count + "_category' name='category[" + category_count + "][category_multi][" + l_id + "]' type='text' value='" + textt + "'>" +
                        "<button class='edit-category-button'>edit</button>" +
                      "</div>";
        }
        
        $("<div class='category-item ui-sortable-handle'>" + element + "</div>").insertBefore('#tip_categories .edit-categories-main-container .clearfix');
        category_count--;
      }
    });    
  }
  
  const managerToolkitRequiredFieldForm = document.querySelectorAll('.manager-toolkit-required-field-form');
  managerToolkitRequiredFieldForm.forEach(function(form){
    const formRequiredFields = form.querySelectorAll('.manager-toolkit-required-fields');
    const ckeditorFields = form.querySelectorAll('.manager-toolkit-ckeditor-required-fields');
    const submitButton = form.querySelector('.submit-button');
    setupUnsavedChangesAlert(form);
    form.addEventListener('submit', function() {
      formChanged = false;
    });
  
    const checkAllFields = function() {
      const allFilled = Array.from(formRequiredFields).every(function(field) {
        return field.value.trim() !== '';
      });
  
      const ckeditorFilled = Array.from(ckeditorFields).every(function(ckeditorField) {
        let ckEditorInstance = CKEDITOR.instances[ckeditorField.id];
        if (ckEditorInstance){
          return ckEditorInstance.getData().trim() !== ''; 
        }
      });
  
      if (allFilled && ckeditorFilled) {
        submitButton.removeAttribute("disabled");
        submitButton.classList.remove("display-tool-tip");
      } else {
        submitButton.setAttribute("disabled", "disabled");
        submitButton.classList.add("display-tool-tip");
      }
    };
  
    formRequiredFields.forEach(function(requiredField) {
      requiredField.addEventListener('input', checkAllFields);
    });
    
    const modalCloseButtons = form.querySelectorAll('.manager-toolkit-with-warning-modal-close');
    modalCloseButtons.forEach(function(button){
      button.addEventListener('click', function(event){
        if (formChanged){
          const confirmation = openConfirmationDialog();
          if (!confirmation) {
            event.preventDefault();
          }
          else{
            formChanged = false;
          }
        }
        else{
          event.preventDefault();
          $('.new-tips-modal').closeModal();
        }
      });
    });
    function openConfirmationDialog() {
      let confirmation = confirm('Are you sure you would to continue without saving? Any content not saved will be lost if you click \'OK\'');
      return confirmation;
    }
    $(document).on('click', "#lean-overlay",function (e) {
      if (formChanged){
        const confirmation = openConfirmationDialog();
        if (!confirmation) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
        else{
          formChanged = false;
          window.location.reload();
        }
      }
      else{
        let $tipsModal = $('.new-tips-modal');
        if ($tipsModal.length && $tipsModal.is(':visible')) {
          $tipsModal.closeModal();
        }
      }
    });
    checkAllFields();
    window.CKEDITOR.on('instanceReady', function() {
      ckeditorFields.forEach(function(ckeditorField) {
        checkAllFields();
        let ckEditorInstance = CKEDITOR.instances[ckeditorField.id];
        if (ckEditorInstance) {
          ckEditorInstance.on('change', checkAllFields);
        }
        for (const instanceName in CKEDITOR.instances) {
          if (CKEDITOR.instances.hasOwnProperty(instanceName)) {
            let ckEditorInstance = CKEDITOR.instances[instanceName];
            if (ckEditorInstance) {
              ckEditorInstance.on('change', function () {
                formChanged = true;
              });
            }
          }
        }
      });
    });
  });
  
  $('.custom-modal-trigger').leanModal({
    dismissible: false,
    ready: function() {
      let visibleModal = $('.modal:visible');
      if(visibleModal.find('.ckeditor-create-tips').length > 0) {
        if (!CKEDITOR.instances['tip_description']){
          CKEDITOR.replace( 'tip_description' );
        }
      }
      if($('.ckeditor-create-tips').length > 0) {
        $.each(visibleModal.find('.ckeditor-create-tips'), function(index, create_tip_elm) {
          if (create_tip_elm && create_tip_elm.id && !CKEDITOR.instances[create_tip_elm.id]){
            CKEDITOR.replace( create_tip_elm.id );
          }
        });
      }
      if($('.ckeditor-edit-tips').length > 0) {
        $.each(visibleModal.find('.ckeditor-edit-tips'), function(index, edit_tip_elm) {
          if (edit_tip_elm && edit_tip_elm.id && !CKEDITOR.instances[edit_tip_elm.id]){
            CKEDITOR.replace( edit_tip_elm.id );
          }
        });
      }
      if($('.ckeditor-menu-items').length > 0) {
        $.each(visibleModal.find('.ckeditor-menu-items'), function(index, edit_menu_elm) {
          if (edit_menu_elm && edit_menu_elm.id && !CKEDITOR.instances[edit_menu_elm.id]){
            CKEDITOR.replace( edit_menu_elm.id );
          }
        });
      }
    }
  });
  const managerPresetChecklists = document.querySelectorAll('.manager_toolkit-manager_checklists-index');
  if (managerPresetChecklists.length > 0){
    const checklistLanguageElements = document.querySelectorAll('.manager-checklist-language');
    checklistLanguageElements.forEach(function(element) {
      element.addEventListener('click', function() {
        const form = element.closest('form');
        form.querySelectorAll('.manager-checklist-language').forEach(function(langElement) {
          langElement.classList.remove('selected');
        });
        element.classList.add('selected');
        const l_id = element.getAttribute('data-language-id');
        const t_id = element.getAttribute('data-checklist-id');

        form.querySelectorAll('.multi-language-field').forEach(function(field) {
          field.style.display = 'none';
        });
        document.getElementById('checklist-item-' + t_id + '-' + l_id).style.display = 'block';
      });
    });
  }
  const managerPresetTips = document.querySelector('.manager_toolkit-tips-index')
  if (managerPresetTips){
    let orderChanged           = false;
    let menuItemOrder          = {};
    let highPerformanceEnabled = document.getElementById('mdl_tip_order').dataset['highPerformanceManagerToolkitSortableEnabled'] == 'true';

    if (highPerformanceEnabled) {
      // Set up a sortable list for each category.

      let elements = document.getElementsByClassName('edit-item-order-main-container');

      for (let i = 0; i < elements.length; i++) {
        let element = elements[i];
        let group   = element.dataset['categoryId'];
        let order   = Array.from(element.getElementsByClassName('order-item-name')).map(el => el.dataset['id']);

        menuItemOrder[group] = order;

        Sortable.create(
          element,
          {
            group: group,
            draggable: '.category-item',
            onStart: function (event) {
              $(event.item).parents('.mam-right.col.l9.m9.right').css('background', '#B2B2B2');
            },
            onSort: function (event) {
              orderChanged = true;

              $('.edit-category-container').css('background', '#FFFFFF');
              $('.edit-category-container').css('color', '#000000');
              $(event.item).parents('.mam-right.col.l9.m9.right').css('background', '#FFFFFF');

              // Reorder the counters (on the left) so that they form 1, 2, 3, 4 etc.

              const categoryItems = $(element).find('.category-item');

              for (let i = 0; i < categoryItems.length; i++) {
                const categoryItem = categoryItems[i];

                $(categoryItem).find('.category-index-number').text((i + 1).toString());
              }
            },
            store: {
              set: function (sortable) {
                let order = sortable.toArray();

                menuItemOrder[sortable.options.group.name] = order;
              }
            }
          }
        );
      }
    } else {
      $('.edit-item-order-main-container').sortable({
        cursor: "grab",
        items: ".category-item",
      });
      
      $('.edit-item-order-main-container').on('sortstart', function() {
        $(this).parents('.mam-right.col.l9.m9.right').css('background', '#B2B2B2');
        $(this).sortable("option", "cursor", "grabbing");
      });
      
      $('.edit-item-order-main-container').on('sortchange', function() {
        orderChanged = true;
      });

      $('.edit-item-order-main-container').on('sortstop', function() {
        let index       = 0;
        let length      = $(this).find('.category-index-number').length;
        let category    = $($(this).find('.order-item-category')[index]).data('id') || 0;

        $('.edit-category-container').css('background', '#FFFFFF');
        $('.edit-category-container').css('color', '#000000');
        $(this).parents('.mam-right.col.l9.m9.right').css('background', '#FFFFFF');
        $('.edit-item-order-main-container').sortable("option", "cursor", "grab");

        menuItemOrder[category] = [];
        while (index < length) {
          $($(this).find('.category-index-number')[index]).text(index + 1);
          let name = $($(this).find('.order-item-name')[index]).data('name');
          menuItemOrder[category].push($($(this).find('.order-item-name')[index]).data('id'));
          $($(this).find('.order-item-name')[index]).text(name);
          $($(this).find('.order-item-name')[index]).data('delete', false);
          index++;
        }
      });
      $('.edit-item-order-main-container').on('sortover', function(ui) {
        $($(ui.item)[0]).css('background', '#FFFFFF');
        $($(ui.item)[0]).css('color', '#000000');
        let name = $($(ui.item)[0]).find('.order-item-name').data('name');
        $($(ui.item)[0]).find('.order-item-name').text(name);
        $($(ui.item)[0]).find('.order-item-name').data('delete', false);
      });
    }
    
    $('.change-order-submit-button').on('click', function() {
      let url = $('.edit-item-order-main-container').data('url');
      $.ajax({
        type: 'POST',
        url: url,
        enctype: 'multipart/form-data',
        data: {
          menu_item_order: menuItemOrder
        },
        success: function() {
          window.location.reload();
        }
      });
    });

    const closeButton = document.querySelectorAll(".close-button-for-tips-order-modal");
    closeButton.forEach(function(button){
      button.addEventListener('click', function(event){
        if(orderChanged){
          const confirmation = confirm('You have unsaved changes. Are you sure you want to leave? All unsaved data will be lost if you click \'OK\'');
          if (!confirmation) {
            event.preventDefault();
          }
          else{
            window.location.reload();
          }
        }
        else{
          $('#mdl_tip_order').closeModal()
        }
      });
    });
    $(document).on('click', "#lean-overlay",function (e) {
      if (orderChanged){
        const confirmation = confirm('You have unsaved changes. Are you sure you want to leave? All unsaved data will be lost if you click \'OK\'');
        if (!confirmation) {
          e.preventDefault();
        }
        else{
          orderChanged = false;
          window.location.reload();
        }
      }
      else{
        let $orderModal = $('.order-tips-modal');
        if ($orderModal.length && $orderModal.is(':visible')){
          $orderModal.closeModal();
        }
      }
    });
  }
  
  const generalSettingForm = document.querySelector('.manager-preset-general-setting-form');
  if (generalSettingForm) {
    const radioButtons              = generalSettingForm.querySelectorAll(".default-language-radio-button");
    let initiallyCheckedRadioButton = generalSettingForm.querySelector(".default-language-radio-button:checked");

    radioButtons.forEach(function(radioButton) {
      radioButton.onchange = function(){
        const confirmation = confirm('Are you sure you would like to change the default language? Custom content may not be translated to the new default language, it is recommend to double check custom content translations');
        if(!confirmation){
          this.checked                        = false;
          initiallyCheckedRadioButton.checked = true;
        }
      }
    });
  }
});
